import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "./FormInput";
import AlertMessage from "./AlertMessage";
import PrimaryButton from "./PrimaryButton";

const FormContainer = ({
  formData,
  errors,
  alert,
  loading,
  loadingText,
  handleInputChange,
  handleClearInput,
  handleButtonClick,
  setAlert
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Enhanced header with icon and styling */}
      <div className="text-center mb-6">
        <h1 className="text-2xl text-slate-700 mb-1 font-heading">
          {t("form_container.title")}
        </h1>
        <p className="text-sm text-slate-600">
          {t("form_container.description")}
        </p>
      </div>

      <AlertMessage alert={alert} onClose={() => setAlert(null)} />

      <FormInput
        id="firstName"
        type="text"
        name="firstName"
        value={formData.firstName}
        onChange={handleInputChange}
        label={t("form_container.first_name_label")}
        error={errors.firstName}
        onClear={() => handleClearInput("firstName")}
        autoCapitalize="words"
      />

      {/*
      <FormInput 
        id="lastName"
        type="text"
        name="lastName"
        value={formData.lastName}
        onChange={handleInputChange}
        label="Nazwisko"
        error={errors.lastName}
        onClear={() => handleClearInput('lastName')}
      />
      */}

      <FormInput 
        id="email"
        type="email"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        label={t("form_container.email_label")}
        error={errors.email}
        onClear={() => handleClearInput("email")}
      />

      <p className="text-xs text-slate-400 text-center mt-2 mb-4 px-2">
        {t("form_container.marketing_disclaimer")}
      </p>

      <PrimaryButton
        onClick={handleButtonClick}
        loading={loading}
        text={t("form_container.submit_button")}
        loadingText={loadingText}
      />
    </>
  );
};

export default FormContainer;